import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const RideTabsBottomSitesTooltipStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "ride-tabs-bottom-sites-tooltip-styled",
  },
)`
  display: flex;
  flex-direction: column;
  gap: 2px;
  white-space: pre-line;
`;
